// src/components/Toast.jsx
import { useEffect } from 'react';
import { FiCheckCircle ,FiAlertCircle} from 'react-icons/fi';
import './Toast.css';

const Toast = ({ message, isSuccess ,isOpen, onClose }) => {
    // Auto-close after 2 seconds
    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(() => {
                clearTimeout(timer);

                onClose();
            }, 2000);

        }
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="toast-overlay">
            <div className="toast-content">
                {isSuccess ? <FiCheckCircle className="checkmark" /> : <FiAlertCircle    className="checkmark" />}
                {/* <FiCheckCircle className="checkmark" /> */}
                <p>{message}</p>
            </div>
        </div>
    );
};

export default Toast;